import { useEffect, useState } from "react";

import { Breakpoints, breakpoints } from "@design-system/tokens/breakpoints";

const getBreakpoint = (width: number): Breakpoint => {
  if (width < breakpoints.mobile) {
    return { name: "mobile", value: Breakpoints.mobile };
  }

  if (width < breakpoints.tablet) {
    return { name: "tablet", value: Breakpoints.tablet };
  }

  if (width < breakpoints.laptop) {
    return { name: "laptop", value: Breakpoints.laptop };
  }

  if (width < breakpoints.desktop) {
    return { name: "desktop", value: Breakpoints.desktop };
  }

  if (width < breakpoints.wide) {
    return { name: "wide", value: Breakpoints.wide };
  }

  return { name: "ultrawide", value: Breakpoints.ultrawide };
};

type Breakpoint = {
  name: keyof typeof breakpoints;
  value: (typeof breakpoints)[keyof typeof breakpoints];
};

export const useBreakpoint = () => {
  const [breakpoint, setBreakpoint] = useState<Breakpoint>(
    getBreakpoint(window.innerWidth),
  );

  useEffect(() => {
    const handleResize = () => {
      setBreakpoint(getBreakpoint(window.innerWidth));
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return {
    value: breakpoint,
    isSmallerThan: {
      mobile: breakpoint.value < breakpoints.mobile,
      tablet: breakpoint.value < breakpoints.tablet,
      laptop: breakpoint.value < breakpoints.laptop,
      desktop: breakpoint.value < breakpoints.desktop,
      wide: breakpoint.value < breakpoints.wide,
      ultrawide: breakpoint.value < breakpoints.ultrawide,
    },
    isLargerThan: {
      mobile: breakpoint.value >= breakpoints.mobile,
      tablet: breakpoint.value >= breakpoints.tablet,
      laptop: breakpoint.value >= breakpoints.laptop,
      desktop: breakpoint.value >= breakpoints.desktop,
      wide: breakpoint.value >= breakpoints.wide,
      ultrawide: breakpoint.value >= breakpoints.ultrawide,
    },
  };
};
